import React from "react";
import styles from "./Testimonials.module.css";
import { AvatarGenerator } from "random-avatar-generator";
import { testimonials } from "../../data";
import TestimonialBox from "../TestimonialBox/TestimonialBox";

interface Testimonial {
  name: string;
  country: string;
  description: string;
}

const Testimonials = () => {
  const generator = new AvatarGenerator();

  return (
    <section id="testimonials" className={styles.container}>
      <h1 className={styles.title}>Don't take my word for it.</h1>
      <h1 className={styles.sub__title}>Trust my clients</h1>
      <div className={styles.grid__box}>
        <div className={styles.col__1}>
          {testimonials.map((testimonial: Testimonial, index: any) => {
            if (index <= 2) {
              return (
                <TestimonialBox
                  key={index}
                  image={generator.generateRandomAvatar()}
                  {...testimonial}
                />
              );
            }
            return null;
          })}
        </div>
        <div className={styles.col__2}>
          {testimonials.map((testimonial: Testimonial, index: any) => {
            if (index > 2 && index <= 5) {
              return (
                <TestimonialBox
                  key={index}
                  image={generator.generateRandomAvatar()}
                  {...testimonial}
                />
              );
            }
            return null;
          })}
        </div>
        <div className={styles.col__3}>
          {testimonials.map((testimonial: Testimonial, index: any) => {
            if (index > 5 && index <= 8) {
              return (
                <TestimonialBox
                  key={index}
                  image={generator.generateRandomAvatar()}
                  {...testimonial}
                />
              );
            }
            return null;
          })}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
